module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-card-actions"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d738b0c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/card/cardActions.vue
// module id = 3716
// module chunks = 1